import { InjectionToken } from "@angular/core";
import { OpenIdConfiguration } from "angular-auth-oidc-client";

export class AppSettings {
    public production = false;
    public baseHref = "";
    public gdprUrl = "";
    public authConfig: OpenIdConfiguration = {};
    public info: ApplicationInfo = {
        product: "",
        version: "",
        fileVersion: "",
        copyright: ""
    };
    public kontakt: Kontakt = {
        namn: "",
        adress: "",
        postadress: "",
        telefon: "",
        epost: "",
        web: ""
    };
}


export interface ApplicationInfo {
    product: string;
    version: string;
    fileVersion: string;
    copyright: string;
}


export interface Kontakt {
    namn: string;
    adress: string;
    postadress: string;
    telefon: string;
    epost: string;
    web: string;
}


export const APP_SETTINGS = new InjectionToken<AppSettings>("appsettings");
